import { useMemo } from 'react';

import { AccountPermission } from 'modules/permissions/constants';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';

export const usePartnerClientStatus = () => {
  const { group } = useAccount();
  const { isLoggedIn } = useAuth();

  const hasJwtReadRoleAccess = useCheckAccountPermission({
    permission: AccountPermission.JwtManagerRead,
  });

  const { jwts, loading: isPartnerStatusLoading } = useJWTs({
    group,
    skipFetching: !group || !isLoggedIn || !hasJwtReadRoleAccess,
  });

  const groupJwt = useMemo(
    () => jwts.find(jwt => jwt.index === 0) ?? jwts[0],
    [jwts],
  );

  const partnerChains = groupJwt?.partnerChains;

  const isPartnerClient = Boolean(
    !isPartnerStatusLoading &&
      groupJwt?.partnerChains &&
      groupJwt?.partnerChains.length > 0,
  );

  return { isPartnerClient, isPartnerStatusLoading, partnerChains };
};
